define('viewmodels/pages/games/gamesTabs',['core/TabSet'], function (TabSet) {

    return function(navigation, getTopGamesField, getAllGamesField, getGamesSearchField) {

        return new TabSet(navigation, 'games', [
            {
                routeConfig: {
                    route: navigation.ROUTES.GAMES_TOP
                },
                title: getTopGamesField('tab_title'),
                icon: 'heart'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.GAMES_ALL
                },
                title: getAllGamesField('tab_title'),
                icon: 'list'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.GAMES_SEARCH
                },
                title: getGamesSearchField('tab_title'),
                icon: 'search'
            }
        ]);
    };
});

